import { customSessionStorage } from 'shared/lib/customStorage';

import { ST_PARENT_ID_SESSION_KEY } from '../constants';

export const getStParentId = () => customSessionStorage.get(ST_PARENT_ID_SESSION_KEY);
